import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopimprichichwadcabs() {



    const cardData = {





keyword: "Mumbai to Pimpri Chinchwad Cabs",

headingDescription: "Shreesha Tours & Travels offers reliable Mumbai to Pimpri Chinchwad Cab Service for corporate travel, employee transportation, business meetings, family trips, industrial visits, and outstation journeys. We provide comfortable chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a smooth journey from Mumbai to Pimpri Chinchwad. With experienced drivers, clean and well-maintained cars, transparent pricing, flexible travel options, doorstep pickup, and 24/7 customer support, we ensure a safe and convenient travel experience. Whether you need a one-way taxi, round trip cab, daily travel solution, or corporate transportation service, Shreesha Tours & Travels provides dependable Mumbai to Pimpri Chinchwad cab booking facilities.",

topPlaces: [
  {
    title: "Pimpri Industrial Area",
    description: "Pimpri is one of Maharashtra's major industrial hubs, known for automobile manufacturing companies, business establishments, and commercial developments. Many professionals and business travelers travel between Mumbai and Pimpri for meetings, industrial visits, and official work. A private cab service offers comfortable and reliable transportation with flexible pickup options."
  },
  {
    title: "Chinchwad Gaon",
    description: "Chinchwad is a well-developed area of Pimpri Chinchwad known for residential communities, temples, educational institutions, and commercial spaces. Travelers visiting Chinchwad for family functions, business purposes, or personal work can enjoy a convenient journey with professional Mumbai to Chinchwad cab services."
  },
  {
    title: "Akurdi Pune",
    description: "Akurdi is an important locality in Pimpri Chinchwad, known for educational institutions, industries, residential areas, and excellent connectivity. It is also close to major corporate zones and manufacturing facilities. Mumbai to Akurdi cab services provide a comfortable travel solution for students, employees, and business visitors."
  },
  {
    title: "Pimpri Chinchwad IT Park",
    description: "Pimpri Chinchwad has developed into a growing business destination with IT companies, technology offices, and commercial centers. Professionals traveling from Mumbai for meetings, conferences, and corporate visits prefer private cabs for convenient and time-saving travel between both cities."
  },
  {
    title: "Dapodi Pune",
    description: "Dapodi is a strategically located area near Pimpri Chinchwad and Pune, known for industrial establishments, residential areas, and important road connectivity. It is frequently visited by business travelers and employees. A comfortable cab service ensures smooth travel from Mumbai to Dapodi with experienced drivers."
  },
  {
    title: "Nigdi Pradhikaran",
    description: "Nigdi Pradhikaran is a planned residential and commercial area of Pimpri Chinchwad known for educational institutions, parks, and modern infrastructure. Families, professionals, and visitors traveling from Mumbai can choose private cab services for convenient and comfortable transportation."
  },
  {
    title: "Talawade IT Park",
    description: "Talawade IT Park is an emerging technology hub near Pimpri Chinchwad, attracting IT companies and professionals. Employees and business visitors often require dependable transportation from Mumbai. Corporate and outstation cab services provide punctual travel solutions with comfortable vehicles."
  },
  {
    title: "Bhosari MIDC",
    description: "Bhosari MIDC is one of Pune region's largest industrial areas, home to manufacturing units, automobile companies, and commercial businesses. Regular travel between Mumbai and Bhosari is common for industrial professionals and business owners. Cab services provide a hassle-free journey for official visits and work-related travel."
  },
  {
    title: "Ravet Pune",
    description: "Ravet is a rapidly developing residential and commercial area near Pimpri Chinchwad, known for modern housing projects, educational institutes, and easy connectivity. Travelers visiting Ravet from Mumbai can enjoy comfortable and direct cab services suitable for families and professionals."
  },
  {
    title: "Lonavala Enroute Stop",
    description: "Lonavala is a scenic hill station located on the Mumbai-Pune route and is a popular stop during Mumbai to Pimpri Chinchwad journeys. Travelers can enjoy beautiful landscapes, Tiger Point, Bhushi Dam, and mountain views. A private cab allows flexible travel breaks and a more comfortable long-distance experience."
  }
],


"services": [
  {
    "name": "Mumbai to Pimpri Chinchwad Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Cab for comfortable and reliable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Kia Carens, Luxury Cab, and Tempo Traveller options for business trips, family travel, corporate transportation, airport transfers, and one-way or round-trip journeys."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Taxi",
    "description": "Reserve Mumbai to Pimpri Chinchwad Taxi for safe and affordable intercity travel with experienced drivers and clean vehicles. Enjoy convenient pickup locations, flexible booking options, transparent pricing, and comfortable taxi services for personal and professional journeys."
  },
  {
    "name": "Mumbai to PCMC Cab",
    "description": "Book Mumbai to PCMC Cab for smooth transportation from Mumbai to Pimpri Chinchwad Municipal Corporation areas. Get reliable chauffeur-driven cabs with multiple vehicle options suitable for families, corporate travelers, and outstation passengers."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Cab Service",
    "description": "Choose Mumbai to Pimpri Chinchwad Cab Service for dependable travel solutions with professional chauffeurs and premium AC vehicles. Enjoy doorstep pickup, comfortable rides, affordable fares, and reliable service for daily travel and long-distance trips."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Taxi Service",
    "description": "Hire Mumbai to Pimpri Chinchwad Taxi Service for convenient transportation with experienced drivers and well-maintained cars. Perfect for business visits, family trips, airport transfers, and regular travel requirements."
  },
  {
    "name": "Mumbai to PCMC Taxi Service",
    "description": "Book Mumbai to PCMC Taxi Service for comfortable and punctual travel between Mumbai and PCMC areas. Enjoy private taxi facilities with clean AC vehicles and professional chauffeurs."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad One Way Cab",
    "description": "Reserve Mumbai to Pimpri Chinchwad One Way Cab for affordable drop taxi service without return charges. Travel conveniently with experienced drivers and flexible pickup timings."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Cab Booking",
    "description": "Complete Mumbai to Pimpri Chinchwad Cab Booking online for quick confirmation and hassle-free travel. Select from Sedan, SUV, Innova, Ertiga, Innova Crysta, and luxury vehicles according to your requirements."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Car Rentals",
    "description": "Choose Mumbai to Pimpri Chinchwad Car Rentals for chauffeur-driven cars with flexible travel options. Get comfortable vehicles for business trips, family vacations, sightseeing, and corporate transportation."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Outstation Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Outstation Cab for safe and comfortable long-distance travel. Enjoy premium AC vehicles, experienced chauffeurs, affordable pricing, and reliable intercity transportation."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Innova Cab",
    "description": "Hire Mumbai to Pimpri Chinchwad Innova Cab for spacious and comfortable journeys with family and groups. Enjoy extra luggage space, premium seating, and smooth travel with professional drivers."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Innova Crysta Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Innova Crysta Cab for luxury travel with premium interiors and superior comfort. Ideal for corporate travel, family trips, and passengers looking for a comfortable long-distance ride."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Ertiga Cab",
    "description": "Reserve Mumbai to Pimpri Chinchwad Ertiga Cab for affordable family travel with spacious seating and comfortable interiors. Enjoy reliable chauffeur-driven cab service for your journey."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Sedan Cab",
    "description": "Choose Mumbai to Pimpri Chinchwad Sedan Cab for economical and comfortable transportation. Get clean AC sedan cars with professional chauffeurs for business and personal travel."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Swift Dzire Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Swift Dzire Cab for budget-friendly travel with smooth rides and experienced drivers. Perfect for small families, couples, and corporate passengers."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad SUV Taxi",
    "description": "Hire Mumbai to Pimpri Chinchwad SUV Taxi for spacious and premium travel with additional luggage capacity. Suitable for families, groups, and comfortable outstation journeys."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Kia Carens Cab",
    "description": "Reserve Mumbai to Pimpri Chinchwad Kia Carens Cab for premium family transportation with modern features and comfortable seating. Enjoy a smooth journey with professional chauffeur service."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Luxury Cab",
    "description": "Book Mumbai to Pimpri Chinchwad Luxury Cab for premium travel experiences with high-comfort vehicles and professional drivers. Ideal for corporate meetings, VIP travel, and special occasions."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad AC Taxi",
    "description": "Choose Mumbai to Pimpri Chinchwad AC Taxi for comfortable travel in clean air-conditioned vehicles. Enjoy safe transportation with reliable drivers and flexible booking options."
  },
  {
    "name": "Mumbai to Pimpri Chinchwad Tempo Traveller",
    "description": "Book Mumbai to Pimpri Chinchwad Tempo Traveller for group transportation with spacious seating and comfortable interiors. Perfect for family tours, corporate groups, and events."
  },
  {
    "name": "Mumbai to Pimpri Cab",
    "description": "Reserve Mumbai to Pimpri Cab for convenient travel with experienced chauffeurs and well-maintained vehicles. Enjoy reliable transportation between Mumbai and Pimpri."
  },
  {
    "name": "Mumbai to Chinchwad Cab",
    "description": "Book Mumbai to Chinchwad Cab for safe and comfortable travel with professional drivers. Get affordable cab service with multiple vehicle options."
  },
  {
    "name": "Mumbai to Akurdi Cab",
    "description": "Hire Mumbai to Akurdi Cab for reliable transportation with clean AC vehicles and experienced chauffeurs. Suitable for personal, business, and family journeys."
  },
  {
    "name": "Mumbai to Nigdi Cab",
    "description": "Choose Mumbai to Nigdi Cab for convenient travel with professional drivers and comfortable vehicles. Enjoy smooth rides from Mumbai to Nigdi."
  },
  {
    "name": "Mumbai to Bhosari Cab",
    "description": "Book Mumbai to Bhosari Cab for affordable and dependable transportation. Get doorstep pickup, clean vehicles, and reliable chauffeur service."
  },
  {
    "name": "Mumbai to Wakad Cab",
    "description": "Reserve Mumbai to Wakad Cab for comfortable travel to Wakad with experienced drivers. Ideal for IT professionals, families, and business travelers."
  },
  {
    "name": "Mumbai to Hinjewadi Cab",
    "description": "Book Mumbai to Hinjewadi Cab for corporate and business travel with punctual pickup services. Enjoy comfortable vehicles suitable for IT park visits and professional trips."
  },
  {
    "name": "Mumbai to Ravet Cab",
    "description": "Choose Mumbai to Ravet Cab for safe and convenient travel with experienced chauffeurs. Get reliable transportation for personal and business requirements."
  },
  {
    "name": "Mumbai to Punawale Cab",
    "description": "Hire Mumbai to Punawale Cab for comfortable intercity travel with affordable pricing and professional drivers. Enjoy smooth journeys with AC vehicles."
  },
  {
    "name": "Mumbai to Tathawade Cab",
    "description": "Book Mumbai to Tathawade Cab for reliable transportation with flexible booking options. Get clean vehicles and experienced chauffeurs for comfortable travel."
  },
  {
    "name": "Mumbai Airport to Pimpri Chinchwad Cab",
    "description": "Reserve Mumbai Airport to Pimpri Chinchwad Cab for direct airport pickup and drop services. Enjoy flight-friendly pickups, luggage assistance, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "One Way Cab Mumbai to PCMC",
    "description": "Book One Way Cab Mumbai to PCMC for economical one-direction travel with transparent pricing. Enjoy comfortable rides without return fare charges."
  },
  {
    "name": "Mumbai to PCMC Innova Crysta Cab",
    "description": "Choose Mumbai to PCMC Innova Crysta Cab for premium and spacious travel. Enjoy luxury interiors, experienced chauffeurs, and comfortable journeys for families and corporate passengers."
  }
],
"tableData": [
  ["Mumbai to Pimpri Chinchwad Cab", "Mumbai to PCMC Cab"],
  ["Mumbai to Pimpri Chinchwad Taxi", "Mumbai to Pimpri Chinchwad Cab Service"],
  ["Mumbai to Pimpri Chinchwad Taxi Service", "Mumbai to PCMC Taxi Service"],
  ["Mumbai to Pimpri Chinchwad One Way Cab", "Mumbai to Pimpri Chinchwad Cab Booking"],
  ["Mumbai to Pimpri Chinchwad Car Rentals", "Mumbai to Pimpri Chinchwad Outstation Cab"],
  ["Mumbai to Pimpri Chinchwad Innova Cab", "Mumbai to Pimpri Chinchwad Innova Crysta Cab"],
  ["Mumbai to Pimpri Chinchwad Ertiga Cab", "Mumbai to Pimpri Chinchwad Sedan Cab"],
  ["Mumbai to Pimpri Chinchwad Swift Dzire Cab", "Mumbai to Pimpri Chinchwad SUV Taxi"],
  ["Mumbai to Pimpri Chinchwad Kia Carens Cab", "Mumbai to Pimpri Chinchwad Luxury Cab"],
  ["Mumbai to Pimpri Chinchwad AC Taxi", "Mumbai to Pimpri Chinchwad Tempo Traveller"],
  ["Mumbai to Pimpri Cab", "Mumbai to Chinchwad Cab"],
  ["Mumbai to Akurdi Cab", "Mumbai to Nigdi Cab"],
  ["Mumbai to Bhosari Cab", "Mumbai to Wakad Cab"],
  ["Mumbai to Hinjewadi Cab", "Mumbai to Ravet Cab"],
  ["Mumbai to Punawale Cab", "Mumbai to Tathawade Cab"],
  ["Mumbai Airport to Pimpri Chinchwad Cab", "One Way Cab Mumbai to PCMC"],
  ["Mumbai to PCMC Innova Crysta Cab", ""]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Pimpri Chinchwad Cab Service",
    WhyChoosedescription: "Shreesha Travels provides comfortable Mumbai to Pimpri Chinchwad cab services for business travellers, families, employees, and personal travel needs. Enjoy a smooth journey with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "Direct Door-to-Door Cab Service",
    WhyChoosedescription: "Get convenient pickup from your home, office, airport, hotel, or preferred location in Mumbai and direct drop service anywhere in Pimpri Chinchwad without changing multiple transport options."
  },
  {
    WhyChooseheading: "Wide Range of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on your passenger count and comfort requirements."
  },
  {
    WhyChooseheading: "Ideal for Corporate & Daily Travel",
    WhyChoosedescription: "Our Mumbai to Pimpri Chinchwad taxis are suitable for corporate meetings, employee travel, industrial visits, business trips, hotel transfers, and regular commuting requirements."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Options",
    WhyChoosedescription: "Book a one-way cab for direct travel or select a round-trip package with flexible return timings, waiting options, and customized travel plans according to your schedule."
  },
  {
    WhyChooseheading: "Experienced Drivers for Mumbai-Pune Routes",
    WhyChoosedescription: "Our professional chauffeurs have excellent knowledge of Mumbai, Pune Expressway, and Pimpri Chinchwad routes, ensuring safe driving, timely service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Cars",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide passengers with a safe, clean, and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Pimpri Chinchwad Cabs with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking assistance, professional chauffeur service, and reliable transportation for your Mumbai to Pimpri Chinchwad journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a cab from Mumbai to Pimpri Chinchwad?",
    answer: "Yes, you can book a private cab from Mumbai to Pimpri Chinchwad for comfortable and convenient travel."
  },
  {
    question: "Do you provide one-way cab service from Mumbai to Pimpri Chinchwad?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Mumbai to Pimpri Chinchwad."
  },
  {
    question: "Can I book a round-trip taxi between Mumbai and Pimpri Chinchwad?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Which vehicles are available for Mumbai to Pimpri Chinchwad travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is this cab service suitable for corporate travel?",
    answer: "Yes, our service is ideal for business meetings, IT professionals, industrial visits, employee transportation, and corporate travel."
  },
  {
    question: "Can I book a cab from Mumbai Airport to Pimpri Chinchwad?",
    answer: "Yes, direct airport transfer cabs are available from Mumbai Airport and Navi Mumbai Airport to Pimpri Chinchwad."
  },
  {
    question: "Can I customize stops during the journey?",
    answer: "Yes, additional stops and customized travel requirements can be arranged according to your trip plan."
  },
  {
    question: "How is the Mumbai to Pimpri Chinchwad cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip type, toll charges, parking fees, and additional requirements."
  },
  {
    question: "Are early morning and late-night cabs available?",
    answer: "Yes, cab bookings can be scheduled according to your preferred travel time."
  },
  {
    question: "How can I book Mumbai to Pimpri Chinchwad Cabs with Shreesha Travels?",
    answer: "Share your pickup location, travel date, passenger count, preferred vehicle, and trip details to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Kulkarni",
    feedback: "Our Mumbai to Pimpri Chinchwad cab journey was very comfortable. The driver was punctual, the vehicle was clean, and the service was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "We booked a family cab from Mumbai to Pimpri Chinchwad and had a smooth experience. The chauffeur was professional and the car was very comfortable.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-pimpri-chinchwad-cabs.webp",
  "description":
    "Book Mumbai to Pimpri Chinchwad Cabs with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for one-way trips, round trips, business travel, family journeys, and long-distance travel from Mumbai to Pimpri Chinchwad with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-pimpri-chinchwad-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Pimpri Chinchwad Cabs | PCMC Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Pimpri Chinchwad Cabs with Shreesha Travels for safe and comfortable taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way trips, round trips, family travel, business journeys, and 24x7 cab booking from Mumbai to Pimpri Chinchwad."
  />

  <meta
    name="keywords"
    content="Mumbai to Pimpri Chinchwad Cab, Mumbai to Pimpri Chinchwad Cabs, Mumbai to PCMC Cab, Mumbai to Pimpri Chinchwad Taxi, Mumbai to PCMC Taxi, Mumbai Pimpri Chinchwad Cab Service, Mumbai to Pimpri Chinchwad Car Rental, One Way Cab Mumbai to PCMC, Round Trip Taxi Mumbai to Pimpri Chinchwad, Pimpri Chinchwad Taxi from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/111.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopimprichichwadcabs;